import React, { useState, useEffect } from "react";
import * as Sentry from '@sentry/react';
import PickupLogin from "../Pages/pickups/login";
import PickupsOrdersScreen from "../Pages/pickups";
import {
    PickupProvider,
    usePickupDispatch,
    usePickupState,
} from "../context/PickupContext";
import LoadingPage from "../Pages/LoadingPage";
import Axios from "axios";
import { Switch, Route, BrowserRouter as Router } from "react-router-dom";
import PickupExpress from "../Pages/pickups/express";

function PickupRoutes() {
    const { user } = usePickupState();
    console.log({ user });
    if (user?.id) {
        return (
            <Router>
                <Switch>
                    <Route
                        exact
                        path="/pickups/express/:store_id"
                        component={PickupExpress}
                    />
                    <Route exact path="/*" component={PickupsOrdersScreen} />
                </Switch>
            </Router>
        );
    }
    return (
        <Router>
            <Switch>
                <Route
                    exact
                    path="/pickups/express/:store_id"
                    component={PickupExpress}
                />
                <Route exact path="/*" component={PickupLogin} />
            </Switch>
        </Router>
    );

}

const InitialPickupRoutes = () => {
    const [loading, setLoading] = useState(true);
    const dispatch = usePickupDispatch();

    useEffect(() => {
        const localStorageAction = async () => {
            try {
                setLoading(true);
                const { data, status } = await Axios.get(
                    "/pickups/requests/logged_in_user"
                );
                if (status == 302) {
                    throw new Error("Err");
                }
                if (data) {
                    if (data.id == null) {
                        throw new Error("Err");
                    }
                    dispatch("SET_AUTH", data);
                }
            } catch (err) {
                console.log("Error Index", err);
            } finally {
                setLoading(false);
            }
        };

        localStorageAction();
    }, []);
    if (loading) {
        return (
            <Router>
                <Switch>
                    <Route exact path="*" component={LoadingPage} />
                </Switch>
            </Router>
        );
    }
    return <PickupRoutes />;
};
export default () => (
    <Sentry.ErrorBoundary fallback={<div>Something went wrong</div>} showDialog>
        <PickupProvider>
            <InitialPickupRoutes />
        </PickupProvider>
    </Sentry.ErrorBoundary>
);
